import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import SeoHelmets from '../SeoOptimazation/SeoHelmets';
import Banner from '../Banner/Banner';
import ContentCard from '../ContentCard/ContentCard';
import Achievements from '../Achivements/Achievements';
import SlickSlider from '../Slider/SlickSlider';
import Expert from '../Expert/Expert';
import Subscribe from '../Subscribe/Subscribe';

function Home({setPrevPath}) {
    useEffect(() => {
        setPrevPath(null);
        window.scrollTo(0, 0);
      }, []);
    return (
        <>
            <SeoHelmets 
                title="Best Coaching Institute for UPSC/IAS Exam - Insight IAS, Delhi" 
                description="Insight IAS Academy Delhi is India's leading coaching institute for UPSC, IAS, CUET, NEET, and UGC NET. Join our expert-led programs and top-rated test series."
                keywords="UPSC coaching Delhi, IAS preparation, Best IAS institute, CUET coaching, NEET preparation, UGC NET JRF, Insight IAS"
            />
            <Banner/>
            <ContentCard />
            <Achievements />
            <SlickSlider />
            <Expert />
            <Subscribe />
        </>
    )
}

export default Home;